function initializeCrystalQuizzes() {
document.querySelectorAll('[data-crystal-quiz]').forEach(root => {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const data = JSON.parse(root.querySelector('[data-quiz-config]').textContent, (key, value) => typeof value === 'string' ? value.replaceAll('&#39;', "'") : value);
  const form = root.querySelector('form');
  const results = root.querySelector('[data-result]');
  const answers = Array(data.questions.length).fill(null);
  let step = 0;
  const find = selector => root.querySelector(selector);
  function render(focus) {
    const question = data.questions[step];
    find('legend').textContent = question.title;
    find('[data-progress]').textContent = data.labels.progress.replace('{{ current }}', step + 1).replace('{{ total }}', data.questions.length);
    find('progress').value = step + 1;
    const options = find('[data-answers]');
    options.replaceChildren();
    question.answers.forEach((answer, index) => {
      const label = document.createElement('label');
      const radio = document.createElement('input');
      radio.type = 'radio'; radio.name = 'crystal-answer'; radio.value = index;
      radio.checked = answers[step] === index;
      radio.addEventListener('change', () => { answers[step] = index; find('[data-error]').textContent = ''; });
      const text = document.createElement('span'); text.textContent = answer;
      label.append(radio, text); options.append(label);
    });
    find('[data-back]').disabled = step === 0;
    find('[data-next]').textContent = step === data.questions.length - 1 ? data.labels.finish : data.labels.next;
    find('[data-error]').textContent = '';
    if (focus) find('legend').focus();
  }
  form.addEventListener('submit', event => {
    event.preventDefault();
    if (answers[step] === null) { find('[data-error]').textContent = data.labels.error; return; }
    if (step < data.questions.length - 1) { step++; render(true); return; }
    const scores = data.results.map((_, index) => answers.reduce((score, answer, q) => score + (answer === index ? (q === 0 ? 3 : 2) : 0), 0));
    const winner = scores.indexOf(Math.max(...scores));
    const result = data.results[winner];
    find('[data-result-name]').textContent = result.name;
    find('[data-result-era]').textContent = result.era;
    find('[data-result-copy]').textContent = result.copy;
    const image = find('[data-result-image]'); image.hidden = !result.image;
    if (result.image) { image.src = result.image; image.alt = result.name; }
    const meaning = find('[data-meaning]'); meaning.hidden = !result.guide;
    if (result.guide) meaning.href = result.guide;
    const shop = find('[data-shop]');
    shop.href = result.shop || '/collections/crystals-kansas-city';
    shop.textContent = result.shop ? data.labels.shop : data.labels.fallback;
    form.hidden = true; results.hidden = false; find('[data-result-name]').focus();
  });
  find('[data-back]').addEventListener('click', () => { if (step > 0) { step--; render(true); } });
  find('[data-restart]').addEventListener('click', () => { answers.fill(null); step = 0; results.hidden = true; form.hidden = false; render(true); });
  form.hidden = false; render(false);
});
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeCrystalQuizzes);
} else {
  initializeCrystalQuizzes();
}
document.addEventListener('shopify:section:load', initializeCrystalQuizzes);

